export async function fetchInboundErrors(sessionId: string, params: any) {
  if (!sessionId || sessionId === '') return;

  return await fetch(`${process.env.REACT_APP_API_PATH}/errorlog/fetchlog`, {
    headers: {
      'x-session-id': sessionId,
    },
    method: 'POST',
    body: JSON.stringify(params),
  })
    .then(async (response) => {
      if (response.status === 200) {
        let json: any = await response.json();
        const dataSortedByDate = json?.data?.logs?.sort((a: any, b: any) => {
          return a.timestamp < b.timestamp ? 1 : a.timestamp > b.timestamp ? -1 : 0;
        });
        return {
          data: dataSortedByDate,
          nextToken: json.data.nextToken,
          status: 200,
        };
      } else {
        return {
          errorMessage: 'Invalid or expired session.',
          status: response.status,
        };
      }
    })
    .catch((error) => {
      return {
        errorMessage: 'Failed to fetch Error logs',
        status: null,
      };
    });
}

export async function updateErrorWebhooks(sessionId: string, errorWebhooks: string[]) {
  if (!sessionId || sessionId === '') return;

  return await fetch(`${process.env.REACT_APP_API_PATH}/errorlog/update_webhooks`, {
    headers: {
      'x-session-id': sessionId,
    },
    method: 'POST',
    body: JSON.stringify({
      errorWebhooks,
    }),
  })
    .then(async (response) => {
      if (response.status === 200) {
        let json = await response.json();
        return {
          data: json?.errorWebhooks,
          status: 200,
        };
      } else {
        return {
          errorMessage: 'Invalid or expired session.',
          status: response.status,
        };
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      return {
        errorMessage: 'Failed to update Error Webhook details',
        status: null,
      };
    });
}
